import { curveLinear, curveLinearClosed } from 'd3-shape';
import { isPolar } from '../../utils/coordinate';
import { Curve } from './curve';
export var Line = function Line(options, context) {
  var coordinate = context.coordinate;
  return function () {
    var curve = isPolar(coordinate) ? curveLinearClosed : curveLinear;
    return Curve(Object.assign({
      curve: curve
    }, options), context).apply(void 0, arguments);
  };
};
Line.props = Object.assign(Object.assign({}, Curve.props), {
  defaultMarker: 'line'
});